import { render } from "./ReviewDetail.vue?vue&type=template&id=d5aaad7a&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"

import "./ReviewDetail.vue?vue&type=style&index=0&id=d5aaad7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5aaad7a"]])

export default __exports__